import ValueItem from './ValueItem'

export default ValueItem
